import React from 'react';
import { AccordionButton, Box, Td } from '@chakra-ui/react';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
const TableAccordionButton = ({ isExpanded }) => {
    const tokens = useTokens();
    return (React.createElement(Td, { w: "56px" },
        React.createElement(AccordionButton, { padding: 0, _hover: { bgColor: 'transparent' } },
            React.createElement(Box, { "aria-label": localise('EXPAND_ROW'), onClick: (event) => event.preventDefault(), py: 3 },
                React.createElement(Chevron, { fill: tokens.IconPrimary, direction: isExpanded ? ChevronDirection.DOWN : ChevronDirection.RIGHT })))));
};
export default TableAccordionButton;
